<p-dialog
  *ngIf="visible"
  header="{{ header }}"
  [style]="{ width: '700px' }"
  [(visible)]="visible"
  [modal]="modal"
  [closeOnEscape]="false"
  [focusOnShow]="true"
  (onHide)="onHide()"
  (visibleChange)="onHide($event)"
  appendTo="body"
  styleClass="dialog alert-dialog alert-dialog--large alert-dialog-info"
  [resizable]="true"
>
  <div class="flex-row flex-align-items-center">
    <clr-icon
      [attr.shape]="severityIcon"
      size="40"
      [attr.class]="'alert-dialog__icon color-' + severityColor"
    ></clr-icon>
    <span class="alert-dialog__message">{{ message }}</span>
  </div>
  <p-footer>
    <button class="button button--main" kpdHotkey="enter" icon="fa-check" (click)="close(verify)" kpdAutofocus>
      {{ verifyLabel }}
    </button>
  </p-footer>
</p-dialog>
